import {
  UPDATE_INVITE_DRIVER_DETAILS,
  UPDATE_PASSWORD_DETAILS,
} from "../constants";

const INITIAL_STATE = {
  inviteDriverDetails: {},
  updatePasswordDetails: {},
};

const verifyUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_INVITE_DRIVER_DETAILS:
      return {
        ...state,
        inviteDriverDetails: action.payload,
      };
    case UPDATE_PASSWORD_DETAILS:
      return {
        ...state,
        updatePasswordDetails: action.payload,
      };
    default:
      return state;
  }
};

export default verifyUserReducer;
